module.exports = __webpack_public_path__ + "img/Transnistria.65d8674b.svg";